var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckbox = function SvgCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M58.445 27.946a1 1 0 1 0-1.47-1.356l-22.82 24.748-11.206-9.806a1 1 0 0 0-1.318 1.505l11.94 10.448a1 1 0 0 0 1.394-.075z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12 10a2 2 0 0 0-2 2v56a2 2 0 0 0 2 2h56a2 2 0 0 0 2-2V12a2 2 0 0 0-2-2zm0 58V12h56v56z",
    clipRule: "evenodd"
  })));
};
export default SvgCheckbox;